import { useCallback } from 'react';

import { createNotification, snackbarModel } from '../../../features/snackbar';
import { useDispatch, useSelector } from 'react-redux';

import { messages } from '../config';
import { generateShareLink } from '../lib';
import { teamsModel } from '../../../features/teams';

export const useShareLink = () => {
  const { id: teamId } = useSelector(
    teamsModel.selectors.selectCurrentTeamWithError
  );

  const dispatch = useDispatch();

  const handleCopyShareLink = useCallback(
    async ({
      path,
      id,
      notification = true,
    }: {
      path: string;
      id: string;
      notification?: boolean;
    }) => {
      const link = generateShareLink(path, id, `${teamId}`);
      await navigator.clipboard.writeText(link);

      if (notification) {
        dispatch(
          snackbarModel.actions.addNotificationAction(
            createNotification('success', messages.success)
          )
        );
      }
    },
    [dispatch, teamId]
  );

  return { handleCopyShareLink };
};
